<div [ngStyle]="{'z-index': zIndex}" class="burndownwidget" #divcontainer>

  <button mat-raised-button class="resetButton" (click)="reset($event)">
    <mat-icon>replay</mat-icon>
  </button>
  <button mat-raised-button class="dragButton" id="dragButtonID" (click)="setWidgetDraggable()">
    <mat-icon>open_with</mat-icon>
  </button>

  <div class="widget">
    <script src="node_modules/chart.js/src/chart.js"></script>

    <div *ngIf="showBurndown">
      <h3 class="widget-title" [translate]="'widgets.burndown.name'"></h3>
      <b style="font-size:80%;" [translate]="'widgets.burndown.sprintduration'">Sprintduration</b>
      <b style="font-size:80%;">: {{selectedSprintDurationAsDays}}</b>
      <b style="font-size:80%;" [translate]="'widgets.burndown.days'"> days</b>
    </div>
    <div *ngIf="!showBurndown">
      <!--TODO - Change static String-->
      <h3 class="widget-title">Burnup</h3>
    </div>


    <!-- TODO - Chane Sprintdauer and Tage-->
    <!--<p style="font-size:80%;">{{sprintName}}</p>-->


    <div class="main-container">
      <div id="canvasContainer">
        <canvas id="burnChart" class="burndownChart" height="450" width="600"></canvas>
      </div>
      <mat-slide-toggle *ngIf="showBurndown" (change)="switchData()" [checked]="showStoryBurn"
                        [translate]="'widgets.burndown.showBurndown'">Show Storypoint-Burndown
      </mat-slide-toggle>


      <div *ngIf="showBurndown">
        <button (click)="switchDiagram()" [translate]="'widgets.burndown.switchBurnUp'">Switch to Burnup</button>
      </div>
      <div *ngIf="!showBurndown">
        <button (click)="switchDiagram()" [translate]="'widgets.burndown.switchBurnDown'">Switch to Burndown</button>
      </div>
      <div *ngIf="displayFinishedTasks">
        <hr>
        <b [translate]="'widgets.burndown.finishedUserstories'">Finished Userstories: </b>
        <li *ngFor="let element of displayFinishedTasks">
          <!--TODO - Change static String-->
          Tag {{displayFinishedTasksDay}}: {{element}}
        </li>
      </div>
    </div>

  </div>

</div>
